import request from '@/router/axios';
export const add = (row) => {
    return request({
        url: '/api/produce/transport-record/insert',
        method: 'post',
        data: row
    })
}
export const update = (row) => {
    return request({
        url: '/api/produce/transport-record/update',
        method: 'post',
        data: row
    })
}
export const getDetail = (id) => {
    return request({
        url: '/api/produce/transport-record/select/id',
        method: 'get',
        params: {
            id
        }
    })
}
export const getList = (params) => {
    return request({
        url: '/api/produce/transport-record/select/page',
        method: 'get',
        params
    })
}
export const exportExcel = (params) => {
    return request({
        url: '/api/produce/transport-record/export',
        method: 'get',
        params,
        responseType: 'blob'
    })
}
export const remove = (ids) => {
    return request({
        url: '/api/produce/transport-record/delete/ids',
        method: 'get',
        params: {
            ids
        }
    })
}

/**
 * 将轨道衡到达记录与到货通知绑定。
 */
export const bindArrivalNotice = (data) => {
    return request({
        url: '/api/produce/transport-record/bind-arrival-notice',
        method: 'post',
        data
    })
}

/**
 * 发送铁路到达通知 MQ（与 /msg/send 中 TYPE_RAILWAY_ARRIVAL 一致），成功后 status=2。
 */
export const sendRailwayArrivalMq = (data) => {
    return request({
        url: '/api/produce/transport-record/send-railway-arrival-mq',
        method: 'post',
        data
    })
}

export const simulateHeavyArrival = (data) => {
    return request({
        url: '/api/produce/transport-record/simulate-heavy-arrival',
        method: 'post',
        data
    })
}

export const simulateEmptyDeparture = (data) => {
    return request({
        url: '/api/produce/transport-record/simulate-empty-departure',
        method: 'post',
        data
    })
}

export const manualCompleteEmptyCarriageException = (data) => {
    return request({
        url: '/api/produce/transport-record/empty-carriage-exception/manual-complete',
        method: 'post',
        data
    })
}
